export const IMPORT_RECEIPT_MS = 7000;

export function importTrayAvailable(tool: string, cropping: unknown) {
  return !cropping && (tool === "select" || tool === "hand");
}
